import { c as _c } from "react/compiler-runtime";
import { IcoChevronDown16 } from '@onefootprint/icons';
import * as RadixSelect from '@radix-ui/react-select';
import { cx } from 'class-variance-authority';
const ScrollButton = t0 => {
  const $ = _c(8);
  const {
    direction
  } = t0;
  const ButtonComponent = direction === "up" ? RadixSelect.ScrollUpButton : RadixSelect.ScrollDownButton;
  const t1 = direction === "up" ? "rotate-180" : "";
  let t2;
  if ($[0] !== t1) {
    t2 = cx("flex items-center justify-center w-full cursor-pointer h-7 hover:bg-hover", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IcoChevronDown16 />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <div className={t2}>{t3}</div>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== ButtonComponent || $[6] !== t4) {
    t5 = <ButtonComponent asChild={true}>{t4}</ButtonComponent>;
    $[5] = ButtonComponent;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default ScrollButton;